import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'
import { useLanguage } from '@/localization'

export default function NotFound() {
  const { t } = useLanguage()

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-[#f4f7f2]">
      <img
        src="/brand/ul-logo.png"
        alt="Uliunai"
        className="w-24 h-24 object-contain mb-6 animate-float"
      />
      <p className="font-pixel text-3xl text-grass-deep mb-4">404</p>
      <h1 className="text-3xl font-extrabold text-slate-deep mb-2">{t('Chunk not found')}</h1>
      <p className="text-slate-deep/70 mb-8 max-w-md">
        {t("This block doesn't exist on our map. Let's get you back to spawn.")}
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-grass-dark hover:bg-grass-deep text-white font-extrabold border-b-4 border-grass-deep shadow-block transition-all active:translate-y-[2px] active:border-b-2"
      >
        <Home size={18} /> {t('Back to home')}
      </Link>
    </div>
  )
}
